import { Layers } from "appworks/graphics/layers/layers";
import { AutoRadioControlFactory } from "appworks/ui/factories/autoplay/auto-radio-control-factory";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsTotalCreditsRadioControl } from "../ags-total-credits-radio-control";

export class AgsTotalCreditsRadioControlFactory extends AutoRadioControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (
            layer.getFlexiButton("total_credits_radio_1") &&
            layer.getFlexiText("total_credits_radio_1_label")
        ) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AgsTotalCreditsRadioControl[] {
        const data = this.getButtonsAndLabels(layer, "total_credits");
        return [
            new AgsTotalCreditsRadioControl(data.buttons, data.labels)
        ];
    }
}
